import React from 'react';

function FlagIconBy({ w, h, style, className }) {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={`${w}px`}
      height={`${h}px`}
      viewBox="0 0 512 512"
      className={className}
      style={style}
    >
      <g fillRule="nonzero" fill="none">
        <circle fill="#F0F0F0" cx="256" cy="256" r="256" />
        <g fill="#D80027">
          <path d="M105.739 237.449l-27.826-50.483 27.826-49.691 27.826 49.691zM50.087 237.449l-27.826-50.483 27.826-49.691 27.826 49.691zM105.739 374.725l-27.826-50.483 27.826-49.691 27.826 49.691zM50.087 374.725l-27.826-50.483 27.826-49.691 27.826 49.691zM133.565 49.692l-7.878-14.068a256.698 256.698 0 0 0-39.594 28.909l19.646 35.641 27.826-50.482zM105.739 411.826l-19.854 35.456a256.711 256.711 0 0 0 39.568 28.955l8.113-14.719-27.827-49.692z" />
        </g>
        <path
          d="M155.826 322.783v168.863C186.595 504.743 220.448 512 256 512c110.071 0 203.906-69.472 240.077-166.957l-340.251-22.26z"
          fill="#6DA544"
        />
        <path
          d="M496.077 345.043C506.368 317.31 512 287.314 512 256 512 114.616 397.384 0 256 0c-35.549 0-69.405 7.253-100.174 20.348v324.696h340.251v-.001z"
          fill="#D80027"
        />
      </g>
    </svg>
  );
}

FlagIconBy.defaultProps = {
  w: 20,
  h: 20,
  style: {},
  fill: '#000',
};

export default FlagIconBy;
